
export default function writefeaturesWithProj(from, to, features, format) {
    var result;
    if (from == to) {
        result = format.writeFeatures(features);
    } else {
        if (from != 'EPSG:3857' && to != 'EPSG:3857') {
            var datas = format.writeFeatures(features, {
                featureProjection: from,
                dataProjection: 'EPSG:3857'
            });
            var new_features = format.readFeatures(datas, {
                featureProjection: to,
                dataProjection: 'EPSG:3857'
            });
            result = format.writeFeatures(new_features);
        } else {
            result = format.writeFeatures(features, {
                featureProjection: from,
                dataProjection: to
            });
        }
    }
    return result;
};
